var singleGlobalFuncPages = (function () {
  return {
    init: init,
  };

  function init() {
    uiBindings();
  }
  
  function uiBindings() {
    window.addEventListener('load', onLoadFunc);
  }

  function onLoadFunc() {
    //table responsive class
    var tableContent = document.querySelectorAll('table');
    for (var j = 0; j < tableContent.length; j++) {
      if (!tableContent[j].parentElement.classList.contains("table-responsive")) {
        var wrapper = document.createElement('div');
        wrapper.classList.add("table-responsive");
        wrapper.appendChild(tableContent[j].cloneNode(true)); 
        tableContent[j].parentNode.replaceChild(wrapper, tableContent[j]);
      }
    }
  }
})();

singleGlobalFuncPages.init();